<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>
  <div class="container-fluid">
    <div class="row">
      <div  class="col-12 errorContainer text-center">
        <ul style="list-style: none">
          <li v-for="errMsg in errMessages" :key="errMsg" >{{errMsg}}</li>
        </ul>
      </div>
    </div>
    <form @submit.prevent="checkLogIn">
      <div class="row">
        <div class="offset-4 col-4">
          <label for="user">User:&nbsp;</label>
          <select style="width:100%" class="form-control" name="user" ref="user" id="user" v-model="user">
            <option disabled value="{}">You must choose a user</option>
            <option v-for="user in users" :key="user" :value="user" :id="user.id">{{ user.getFullName() }}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="offset-4 col-4 ">
          <label for="password">Password:&nbsp; </label>
          <input class="form-control" type="password" id="password" ref="password" v-model="password"/>
        </div>
      </div>

    </form>
    <br><br>
    <div class="row">
      <div class="col-6 text-center">
        <button class="btn-success" @click="checkLogIn">Submit</button>

      </div>
      <div class="col-6 text-center">
        <button class="btn-danger" @click="password=''">Clear Password</button>
      </div>
    </div>
  </div>
</template>

<script>
import {User} from "../classes/User";
import {Job} from "../classes/Job";
import moment from "moment";
import {Appointment} from "../classes/Appointment";
import {useRouter} from "vue-router";
//import {TimeCard} from "@/classes/TimeCard";


export default {
  setup(){

  },
  name: "Login",
  data() {
    return {
      errMessages: [],
      //users: this.$store.state.users,
      password: "",
      user: {},
      router: useRouter()
    }
  },

  async created() {
    //console.log("time card:")

    // let mom = new moment()
    // console.log("moment as string")
    // console.log(mom.toString())
    // console.log("as JSON")
    // console.log(mom.toJSON().toString())


    // let timeCard = new TimeCard()
    // let start = new moment()
    // let end = new moment().add(4.5,"hours")
    //
    // timeCard.startTime = start;
    // timeCard.endTime = end;
    //
    // console.log(timeCard.getHoursWorked())


    // get the users
    await this.$http.get("https://1zo88r48t3.execute-api.us-east-1.amazonaws.com/prod/users").then(response =>{
      let users = response.data;
      if(users) {
        for (let idx = 0; idx < users.length; idx++) {
          users[idx] = User.convertObject(users[idx])

        }
        // console.log("users:")
        // console.log(users)
        this.$store.commit("setUsers", users);
      }
    }).catch(err =>{
      console.log(err);
    });
    // now get the jobs

    await this.$http.get("https://1zo88r48t3.execute-api.us-east-1.amazonaws.com/prod/jobs").then(response =>{
      let jobs = response.data;
      // console.log(jobs)
      if(jobs){
        for (let idx = 0; idx < jobs.length; idx++) {
          jobs[idx]  = Job.convertObject(jobs[idx]);

        }
        //console.log("Setting users...")
        this.$store.commit("setJobs",jobs);
      }
    }).catch(err =>{
      console.log(err);
    });

    // get the monthly rota
    let data = new FormData()
    data.set("moment",new moment().toJSON())
    await this.$http.post("https://v6qpbhpolxm5ugtondpjvn7lxu0qhwiw.lambda-url.us-east-1.on.aws/",data,null).then(response =>{
      //console.log(response)
     // console.log(response.data)
      let rota = response.data;
      if(rota){
        for (let idx = 0; idx < rota.length; idx++) {
          rota[idx]  = Appointment.convertObject(rota[idx]);


        }

        this.$store.commit("setRota",rota);
      }
    }).catch(err =>{
      console.log(err);
    });


    if(this.users.length===0){
      let user = new User("admin");
      user.setPassword("admin");
      user.id = "1";
      user.isAdmin = true;
      // let fakeUser = new User("foo","","a really long last name here it is and more");
      // fakeUser.setPassword("foo");

      this.users.push(user);
      //this.users.push(fakeUser);
    }
  },
  methods: {
    checkLogIn() {
     // console.log("should see this")
      this.errMessages = [];
      //console.log(this.$refs.user.selectedIndex);
      if(!this.$refs.user || this.$refs.user.selectedIndex === -1){
        this.errMessages.push("You must choose a user");
        return false;
      }
      if(this.password.trim()===""){
        this.errMessages.push("You must enter a password!");
        return false;
      }
      //console.log("Made it here")
      if(!this.user.comparePasswords(this.password)){
        ///console.log("compared passwords done");
        this.errMessages.push("Incorrect password");
        return false;
      }

      this.$store.state.loggedInUser = this.user;
      //.log("store logggedIn user")
      //.log(this.$store.state.loggedInUser)
     // const router = useRouter();

      if(this.$store.getters.FirstThing){
        if(this.$store.getters.NoJobs) {

          this.router.push("/admin/manageJobs");
        }else if(this.$store.getters.NoUsers){
          this.router.push("/admin/manageUsers");
        }
        return true;
      }
      //debugger
      this.router.push({name:"Home"});
      return true;
    }
  },
  computed:{
    users(){
      return this.$store.state.users;
    }
  },
}
</script>

<style scoped>
select option,
#user{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 150px;
}
.errorContainer{
  color:red;

}
</style>
